// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  AccountingAreaId,
  AccountingAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  AccountingAreaNavigation,
  AccountingAreaNavigationIcon,
} from './AccountingAreaNavigation'

const LazyAccountingComponent = lazy(() => import('./AccountingArea'))

const AccountingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAccountingComponent />
  </SuspenseLoadingWrapper>
)

export const AccountingArea = {
  id: AccountingAreaId,
  requiredRight: BoumRight.AREA_ACCOUNTING,
  Icon: AccountingAreaNavigationIcon,
  NavigationComponent: AccountingAreaNavigation,
  route: {
    path: AccountingAreaRoutes.route,
    component: AccountingComponent,
  },
}
